<div class="mt-3">
  <div class="gallery">
    <div class="row">
      <div class="col">
        <ngb-carousel
        (slide)="onSlide($event)"
        [showNavigationIndicators]="false" #galleryCarousel [interval]="0">
          <ng-template ngbSlide *ngIf="photo360()" id="id0">
            <div class="picsum-img-wrapper-bid img-slideshow-gallery">
              <div class="relative top-image" (mouseenter)="mouseEnter()" *ngIf="!show360()">
                <app-app-image-multiple-quality *ngIf="firstLoaded()"
                  [imagePath]="selectedAuction().article.articlePhoto360Url + this.selectedAuction().article.idArticle + '_1.jpg'"
                  [hq]="true" class=" img-slideshow-gallery" [minWidth]="600" [maxWidth]="imageWidth()" />

                <div class="preview-icon-360">
                  <img src="/assets/img/360_view.svg" alt="360" />
                </div>
              </div>

              <div id="cloudimage-360" [attr.data-folder]="
                  selectedAuction().article.articlePhoto360Url
                " [attr.data-filename]="getFullAttachmentPath()" [attr.data-amount]="frames()"></div>
            </div>
          </ng-template>
          <ng-template ngbSlide *ngFor="
              let slide of selectedAuction().article.articlePhotoList;
              let i = index
            " id="{{ 'id' + (i + 1) }}">
            <div class="picsum-img-wrapper-bid">
              <app-app-image-multiple-quality [imagePath]="slide.fullPath" class="img-slideshow-gallery" [hq]="id()==('id'+(i+1)) || id()===('id'+(i+2))"
                [loading]="i > 1 ? 'lazy' : 'eager'" [minWidth]="600" [maxWidth]="imageWidth()" />
            </div>
          </ng-template>
        </ngb-carousel>
      </div>
    </div>

    <div class="row gallery-thumbnails">
      <div class="col-2 mt-2" *ngIf="photo360()">
        <img (click)="navigateToSlide('id0')" src="/assets/img/360_view.png" alt="360" class="img-click" />
      </div>

      @for (slide of selectedAuction().article.articlePhotoList; track
      slide.fullPath; let i = $index){
      <div class="col-2 mt-2">
        <img (click)="navigateToSlide('id' + (i + 1))" [src]="slide.fullPath + '?w=100'" alt="Gallery image" class="img-click"
          alt="Gallery image" />
      </div>
      }
    </div>
  </div>
</div>
